import React, { useState } from 'react';
import { DropdownMenu, Icon } from '@kontentino/ui';
import { faLanguage } from '@fortawesome/pro-regular-svg-icons/faLanguage';
import { useTranslation } from 'react-i18next';
import useAppLanguage from 'app/modules/translations/hooks/useAppLanguage';
import SearchTextInput from 'app/components/SearchTextInput';
import StringUtils from 'utils/string';
import VerticalNavigationDropdownOption from './UserActionDropdownOption';

const LanguageSubmenu: React.FC = () => {
  const { setLanguage, languageOptions } = useAppLanguage();
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  const filteredOptions = search
    ? languageOptions.filter((option) =>
        StringUtils.isSubstring(search, option.name),
      )
    : languageOptions;

  return (
    <DropdownMenu.Sub>
      <DropdownMenu.SubTrigger>
        <DropdownMenu.Item
          data-name="navbar_settings_language"
          data-cy="navbar_settings_language"
        >
          <VerticalNavigationDropdownOption
            icon={<Icon icon={faLanguage} size="sm" />}
            label={t('language')}
          />
        </DropdownMenu.Item>
      </DropdownMenu.SubTrigger>
      <DropdownMenu.Portal>
        <DropdownMenu.SubContent className="tw-z-[100] tw-flex tw-h-[350px] tw-flex-col tw-overflow-hidden tw-py-0">
          <div
            className="tw-shrink-0 tw-border-b tw-border-grayscale-10 tw-p-2"
            onKeyDown={(e) => e.stopPropagation()}
          >
            <SearchTextInput
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClear={() => setSearch('')}
              autoFocus
              data-cy="navbar_settings_language_search"
            />
          </div>
          <div className="tw-flex tw-flex-col tw-gap-2 tw-overflow-y-auto tw-py-2">
            {filteredOptions.map((option) => (
              <div key={option.key}>
                <DropdownMenu.Item
                  selected={option.isActive}
                  onClick={() => setLanguage(option.key)}
                  data-cy={`settings_language_${option.key}`}
                >
                  <span
                    role="img"
                    aria-label={option.name}
                    className="tw-leading-none"
                  >
                    {option.flag}
                  </span>
                  {option.name}
                </DropdownMenu.Item>
              </div>
            ))}
            {filteredOptions.length === 0 && (
              <div className="tw-px-4 tw-py-3 tw-text-sm tw-text-grayscale-100">
                {t('noLanguagesFound')}
              </div>
            )}
          </div>
        </DropdownMenu.SubContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Sub>
  );
};

export default LanguageSubmenu;
